import './assets/styles/App.css';
import Header from './components/Header.jsx';
import Hero from './components/Hero.jsx';
import Servicos from './components/Servicos.jsx';
import SchoolServices from './components/SchoolServices.jsx';
import Painel from './components/Painel.jsx';
import Recomendacoes from './components/Recomendacoes.jsx';
import Footer from './components/Footer.jsx';
import BotaoZap from './components/BotaoZap.jsx';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Servicos />
        <SchoolServices />
        <Recomendacoes />  
        <Painel 
          titulo='Estragou? Sem problemas, nós consertamos!'
          descricao='Chame a Ifix e tenha seu problema resolvido rapidamente!'
          cor="#ff6200" 
          corTexto="#fff"
          textoBotao="Ligue agora"
        />
      </main>
      <Footer />
      <BotaoZap />
    </div>
  );
}

export default App;